'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/bid/BidIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var BidIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.70943 16.5H15.2906L16.2906 19.5H17.5V21H2.5V19.5H3.70943L4.70943 16.5ZM5.29057 19.5H14.7094L14.2094 18H5.79057L5.29057 19.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.5 12.5H5.5V14H1.5V12.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.8502 7.2002L7.0502 9.6002L6.1502 10.8002L2.9502 8.4002L3.8502 7.2002Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0001 2.18945L20.8108 6.00011L17.4358 9.37511L22.3108 14.2501L21.2501 15.3108L16.3751 10.4358L13.0001 13.8108L9.18945 10.0001L17.0001 2.18945ZM11.3108 10.0001L13.0001 11.6895L18.6895 6.00011L17.0001 4.31077L11.3108 10.0001Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

export {
  BidIcon
};
//# sourceMappingURL=chunk-EDKX2L42.mjs.map